import React, { useState } from 'react';
import { Button, Slider } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import Styles from '../ApiKeys.module.scss';
import ApiKeysEditForm from '../../containers/ApiKeysEditForm';

export type MapStatePropsType = {
	params: any;
};

export type DispatchPropsType = {
	onClose: () => void;
};

const APIKeyEdit: React.FC<MapStatePropsType & DispatchPropsType> = ({
	onClose,
    params
}) => {
	const { t } = useTranslation();
	const [editDisable, setEditDisable] = useState(false);
	const [editSave, setEditSave] = useState(false);
	const getFooter = (): React.ReactNode => {
		return (
			<div className={Styles.footerContainer}>
				<Button type="tertiary" onClick={onClose}>
					{t('mainCancel')}
				</Button>
				<Button
					type="primary"
					onClick={() => setEditSave(true)}
					disabled={editDisable}
				>
					{t('mainSave')}
				</Button>
			</div>
		);
	};

	return (
		<Slider
			containerId="root-modal"
			onClose={onClose}
			visibility={true}
			footer={getFooter()}
			title={t('editAPIKey')}
		>
			<div className={Styles.container}>
				<ApiKeysEditForm
					onCancel={onClose}
					item={params}
					save={editSave}
					onDisable={(val: boolean) => setEditDisable(val)}
					onResetSave={() => setEditSave(false)}
				/>
			</div>
		</Slider>
	);
};

export default APIKeyEdit;
